import styled from '@emotion/styled'

import { ComponentsGroup } from '../ComponentsGroup'

export const CheckboxGroupWrapper = styled(ComponentsGroup)``
